import { render, staticRenderFns } from "./SearchBlockForms.vue?vue&type=template&id=36601b7f&scoped=true"
import script from "./SearchBlockForms.vue?vue&type=script&lang=js"
export * from "./SearchBlockForms.vue?vue&type=script&lang=js"
import style0 from "./SearchBlockForms.vue?vue&type=style&index=0&id=36601b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36601b7f",
  null
  
)

export default component.exports